import React from 'react';

export const GPX = props => React.createElement('gpx', props);
export const Route = props => React.createElement('rte', props);
export const RoutePoint = props => React.createElement('rtept', props);
export const Elevation = props => React.createElement('ele', props);
